import { render } from "./SampleServiceIcon.vue?vue&type=template&id=902065e2"
import script from "./SampleServiceIcon.vue?vue&type=script&lang=js"
export * from "./SampleServiceIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__